<template>
  <div class="app">
    <BannerSection />
    <div
      class="d-flex justify-center align-center text-center py-8 py-md-12 px-4"
      style="background: linear-gradient(90deg, #2e7d32, #43a047);"
      v-if="showNationalHeroesDay2025Promo"
    >
      <div
        class="white--text"
        style="font-weight: 700; font-size: 1.25rem; max-width: 800px; line-height: 1.6;"
      >
        <div class="text-uppercase mb-2" style="font-size: 1.5rem;">
          🎉 Penawaran Terbatas!
        </div>
        <span class="font-weight-medium"
          >Spesial tanggal <b>10 November</b> — peserta yang menyelesaikan
          pendaftaran hingga tahap cetak kartu akan mendapatkan
          <b>biaya pendaftaran sebesar Rp10</b>!</span
        >
      </div>
    </div>
    <div
      grid-list-xs
      class="d-flex justify-center align-center py-6 py-md-10 accentDarkBlue"
    >
      <div class="font-weight-bold white--text big-div-font text-center">
        Download JUKNIS (Petunjuk Teknis)
        <a
          target="__blank"
          href="https://drive.google.com/file/d/1dxhju49qO78REszSH4yj2QwIm2w4H_Vq/view?usp=sharing"
          >di sini</a
        >
      </div>
    </div>

    <!-- <BannerMajorSection /> -->
    <StepSection />
    <SyaratPendaftaranSection :cardWidth="cardWidth" />
    <BerkasPendaftaranSection :cardWidth="cardWidth" />
    <TimelineSection v-if="currentWave" :currentWave="currentWave" />
    <MajorSection
      v-if="currentWave || sw_status > 7"
      :hasRegister="hasRegister"
      :studentMajor="info.sw_jurusan"
      :id_status="sw_status"
    />
    <ClosedWaveSection v-if="!currentWave && sw_status < 8" />
    <div class="white-section"></div>
  </div>
</template>

<script>
import BannerSection from "../components/Home/BannerSection";
import StepSection from "../components/Home/StepSection";
import MajorSection from "../components/Home/MajorSection";
// import BannerMajorSection from "../components/Home/BannerMajorSection";
import TimelineSection from "../components/Home/TimelineSection";
import ClosedWaveSection from "../components/Home/ClosedWaveSection";
import SyaratPendaftaranSection from "../components/Informasi/Syarat.vue";
import BerkasPendaftaranSection from "../components/Informasi/BerkasPendaftaran.vue";

export default {
  name: "Home",
  props: ["date", "id", "hasRegister", "info", "currentWave", "sw_status"],
  components: {
    BannerSection,
    // BannerMajorSection,
    StepSection,
    MajorSection,
    TimelineSection,
    ClosedWaveSection,
    SyaratPendaftaranSection,
    BerkasPendaftaranSection,
  },
  data: () => ({
    cardWidth: "another-card-width",
    showNationalHeroesDay2025Promo: false,
  }),
  mounted() {
    const today = new Date();
    // Show promo from 7 - 10 November 2025
    const promoStartDate = new Date("2025-11-07");
    const promoEndDate = new Date("2025-11-10");
    if (today >= promoStartDate && today < promoEndDate) {
      this.showNationalHeroesDay2025Promo = true;
    }
  },
};
</script>

<style scoped>
.big-div-font {
  font-size: 1.3rem;
  width: 84%;
}
.white-section {
  min-height: 200px;
}
</style>
